import { render, staticRenderFns } from "./CurrentCardNumberSection.vue?vue&type=template&id=70475988&scoped=true"
import script from "./CurrentCardNumberSection.vue?vue&type=script&lang=ts"
export * from "./CurrentCardNumberSection.vue?vue&type=script&lang=ts"
import style0 from "./CurrentCardNumberSection.vue?vue&type=style&index=0&id=70475988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70475988",
  null
  
)

export default component.exports